import { HttpClient } from '@angular/common/http';
import { NotificationService } from '@enerbim/commons-lib';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@enerbim/commons-lib";
class FileDownload {
    constructor(url) {
        this.url = url;
    }
}
export class FileService {
    constructor(http, notificationService) {
        this.http = http;
        this.notificationService = notificationService;
    }
    download(id, idElement, callback) {
        // Récupère le token
        let fileDownloadTokenUrl = `${environment.apiUrl}/fs/fichiers/${id}/get-download-token`;
        if (idElement) {
            fileDownloadTokenUrl += `?idElement=${idElement}`;
        }
        this.http.get(fileDownloadTokenUrl).subscribe(f => {
            // Crée un lien virtuel pour pouvoir télécharger le fichier (et éviter le soucis avec le JWT)
            const anchor = document.createElement('a');
            anchor.href = `${environment.apiUrl}${f.url}`;
            const event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            anchor.dispatchEvent(event);
            anchor.remove();
            if (callback) {
                callback();
            }
        }, error => {
            if (error.status === 404) {
                this.notificationService.error('Le fichier n\'a pas pu être trouvé. Merci de contacter le support.');
            }
            else {
                this.notificationService.error('Une erreur inconnue s\'est produite. Merci de contacter le support.');
            }
            if (callback) {
                callback();
            }
        });
    }
}
FileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileService_Factory() { return new FileService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.NotificationService)); }, token: FileService, providedIn: "root" });
